//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as settingAction from '../action/settingAction';

import Button from '@material-ui/core/Button';

//Material-ui


//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import TextareaAutosize from 'react-textarea-autosize';

import PartPageTitle from './PartPageTitle';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      loginPass: '',
      loginPassError: null,
      confirm: false,
      experience: '',
      outageDialog: false
    }
	}

  componentDidMount() {
    document.title = '退会 - パートナーズ';
  }

  componentWillUnmount() {
    this.setState({confirm: false});
  }

  _loginPassEdit(value) {
    this.setState({ loginPass: value});
    let errorComment;

    if (value.length < 4 || value.length > 20) {
  		errorComment = '4～20文字で入力してください';
  	}
  	else if (value.match(/^[a-zA-Z0-9]+$/) == null) {
  		errorComment = '入力できない文字が含まれています';
  	}
  	if (errorComment) {
  		this.setState({loginPassError: errorComment});
  	}
  	else {
      this.setState({loginPassError: null});
    }
  }

  _outageCheck() {
    if (this.state.loginPassError) {
      return false;
    }

    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'check');
    params.append('loginPass', this.state.loginPass);
    return axios.post(config.apiUri + "member/settingOutageApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if (res.data.bool) {
        this.setState({confirm: true});
      }
      else {
        this.props.snackOpen('error', res.data.comment, 5000);
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }


  _outageSubmit() {
    if (this.state.loginPassError) {
      return false;
    }

    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'submit');
    return axios.post(config.apiUri + "member/settingOutageApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if (res.data.bool) {
        this.setState({confirm: true});
      }
      else {
        this.props.snackOpen('error', 'パスワードが一致しませんでした', 5000);
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'退会'}
          onback={ '/setting/' }

        />

        <div>

          {
            (!this.state.confirm) ? (
              <div>
                <div style={{padding:'10px'}}>
                  退会後すぐに再登録はできない場合がございます。
                  再開される可能性がある場合、サービスの停止を行ってください。
                  <div align='center' style={{padding:'10px'}}>
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{minWidth:'240px'}}
                      onClick={ () => this.props.history.push('/setting/stop/') }
                    >
                      <span style={{fontSize:'1.2em'}}>停止する</span>
                    </Button>
                  </div>
                </div>
                <div style={{padding:'10px'}}>

                  <div>
                    退会すると、アカウントはすべて閉鎖されます。
                    メールや有料サービスの期間などもすべて破棄される為、アカウントの復帰は行えません。
                  </div>
                  <div style={{padding:'10px'}}>
                    <div
                      style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                        padding:'10px',
                      }}
                    >
                      <h3>ログインパスワード</h3>
                      <span className='blue_icon'>必須</span>
                    </div>

                    <div>
                      ログインパスワードが判らない場合は再設定してください。
                    </div>
                    <div>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={ () => this.props.history.push('/setting/loginPass/') }
                      >
                        パスワードの再設定
                      </Button>
                    </div>

                    <div>
                      英数4～20文字
                      <input
                        type="text"
                        value={ this.state.loginPass }
                        style={{fontSize:'1.2em'}}
                        className="input_blue round12"
                        onChange={ (e) => this._loginPassEdit(e.target.value) }
                      />
                      <div style={{color:'red'}}>{this.state.loginPassError}</div>
                    </div>
                  </div>
                </div>

                <div align='center' style={{padding:'10px'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{minWidth:'240px'}}
                    onClick={ () => this._outageCheck() }
                  >
                    <span style={{fontSize:'1.4em'}}>確認</span>
                  </Button>
                </div>
              </div>
            ):
            (
              <div>
                <div style={{padding:'15px'}}>


                  <span className='blue_icon'>任意</span>退会理由

                  <div>
                    ご利用された感想などございましたらご記入ください
                  </div>
                  <div>
                    <TextareaAutosize
                      value={this.state.experience}
                      className="input_blue round6"
                      onChange={(e) => this.setState({ experience: e.target.value})}
                      style={{
                        fontSize: '1.2em',
                      }}
                      minRows={6}
                      maxLength={500}
                    >
                    </TextareaAutosize>
                    <div align='right'>{this.state.experience.length}/500文字</div>
                  </div>

                </div>

                <div align='center' style={{padding:'10px'}}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{minWidth:'240px'}}
                    onClick={ () => this.setState({outageDialog: true}) }
                  >
                    <span style={{fontSize:'1.4em'}}>退会する</span>
                  </Button>
                </div>
              </div>
            )
          }

        </div>



        <DialogConfirm
          open={ this.state.outageDialog }
          title={'退会'}
          content={(
            <div>
              <div>本当に退会してもいいですか？</div>
              <div>退会ボタンを押されますと、取り消しは行えません<br/>
                退会が完了すると自動的にログアウトいたします
              </div>
            </div>
          )}
          apply={ () => this.props.settingOutage(this.state.experience) }
          close={ () => this.setState({outageDialog: false}) }
        />


      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...uiAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
